/*eslint-disable*/
import React from 'react';

import {
  Badge,
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
  Button,
  Modal,
} from 'reactstrap';

import utils from '../utils.js';
import { Redirect } from 'react-router-dom';

class AccountSwitcher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
    };
  }

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  handleAddLiteButton = async () => {
    // if (this.props.license && this.props.license.amLitePaidInstances) {
    //   this.setState({
    //     alreadySubbedModal: true,
    //   });
    //   await utils.sleep(5000);
    //   window.location.href = `${utils.getEndpoint()}/stripe/customer-portal`;
    //   return;
    // }
    this.setState({
      redirect: '/subscribe?plan=lite',
    });
  };

  renderAlreadySubbedModal = () => {
    return (
      <>
        <Modal
          className="modal-dialog-centered"
          style={{ maxWidth: '800px' }}
          isOpen={this.state.alreadySubbedModal}
          // toggle={() => this.toggleModal('alreadySubbedModal')}
          animation={false}
        >
          <div className="modal-header mb-0 pb-0">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              // onClick={() => this.toggleModal('alreadySubbedModal')}
            >
              {/*<span aria-hidden={true} style={{ fontSize: '41px' }}>*/}
              {/*  ×*/}
              {/*</span>*/}
            </button>
          </div>
          <div className="modal-body px-6 pb-5">
            <div className="text-center pb-3">
              <h1>
                You can add Lite instances in the billing portal. Redirecting...
              </h1>
              <br />
              <div>
                Click "<b>Update quantity</b>" in the billing portal to change
                your number of Lite instances.
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  };

  renderDropdown() {
    let currCredentialNum = 0;
    const selectedCred = this.props.selectedCred;
    const selectedAccount = this.props.selectedAccount;
    const credentials = this.props.credentials || [];
    const numEmptyInstances = credentials.filter((c) => !c.account).length;

    return (
      <>
        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
          <DropdownToggle caret>
            {this.props.credentialsLoading ? (
              'Loading accounts...'
            ) : selectedCred ? (
              <span>
                {utils.renderCredBadge(selectedCred)}
                {selectedAccount ? (
                  <>
                    {selectedAccount.email}
                    {selectedAccount.vaStatus !== 'active' ? (
                      <small className="text-orange"> (disabled)</small>
                    ) : null}
                  </>
                ) : (
                  <span className="text-orange">No account</span>
                )}
              </span>
            ) : (
              'Could not select account. Please contact support.'
            )}
          </DropdownToggle>
          {/* <Button
            className="btn-icon btn-3 float-right"
            type="button"
            color="success"
            size="md"
            onClick={this.handleAddLiteButton}
            style={{
              position: 'absolute',
              fontSize: '0.875rem',
              paddingBottom: '12px',
              paddingRight: '10px',
              paddingLeft: '16px',
            }}
          >
            <span className="btn-inner--icon">
              <span style={{ marginRight: '8px' }}>+</span>
              <span className="">Add Lite Instances</span>
            </span>
          </Button> */}
          <DropdownMenu>
            <DropdownItem header className="text-black-50">
              Instances
            </DropdownItem>
            {credentials.map((c) => {
              const account = c.account;
              currCredentialNum++;
              return (
                <span key={`${currCredentialNum}`}>
                  <DropdownItem
                    style={{ cursor: 'pointer' }}
                    onClick={() => this.props.switchToCred(c)}
                    className="py-3"
                  >
                    {utils.renderCredBadge(c)}
                    {account ? (
                      <>
                        <b className="font-weight-600">{account.email}</b>
                        {c.credId == selectedCred.credId ? (
                          <small> (current)</small>
                        ) : null}
                        {c.account && c.account.vaStatus !== 'active' ? (
                          <small className="text-red"> (disabled)</small>
                        ) : null}
                      </>
                    ) : (
                      <span className="font-weight-600 text-red">
                        No account
                      </span>
                    )}
                  </DropdownItem>
                  {/*<DropdownItem text>Dropdown Item Text</DropdownItem>*/}
                  {/*<DropdownItem disabled>Action (disabled)</DropdownItem>*/}
                  {/*{currCredentialNum < credentials.length ? (*/}
                  <DropdownItem divider className="m-0" />
                  {/*) : null}*/}
                </span>
              );
            })}

            <DropdownItem disabled className="py-3">
              <span
                className="text-blue"
                style={{ cursor: 'pointer' }}
                id="tt1"
              >
                What's an instance?
              </span>
            </DropdownItem>
            <UncontrolledTooltip delay={0} placement="right" target="tt1">
              An instance represents the dedicated server space and
              retailer-optimized proxy that houses an account. All instances run
              independently and attempt at the same time across all users.
            </UncontrolledTooltip>

            <DropdownItem divider className="m-0" />

            <DropdownItem disabled className="py-3">
              <span
                className="text-blue"
                style={{ cursor: 'pointer' }}
                id="tt2"
              >
                What's Lite?
              </span>
            </DropdownItem>
            <UncontrolledTooltip delay={0} placement="right" target="tt2">
              A Lite instance is the same as a regular instance but restricted
              to high-stock items like consoles.
            </UncontrolledTooltip>
          </DropdownMenu>
        </Dropdown>

        {this.props.license &&
        this.props.license.isProEligible &&
        this.props.license.licenseType === 'lite' &&
        this.props.user &&
        !utils.isProUpgradeExpired(this.props.user.notifyProUpgradeISOTime) ? (
          <div>
            <a href="/dashboard/subscribe">
              <Button
                className="btn-icon btn-3 mt-4"
                type="button"
                color="warning"
                size="md"
              >
                <span className="btn-inner--icon">
                  <span className="">Upgrade to Pro ➔</span>
                </span>
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
                  style={{
                    right: '-12px',
                    top: '-11px',
                    backgroundColor: '#2a4f8e',
                  }}
                >
                  Limited spots
                </span>
              </Button>
            </a>
          </div>
        ) : null}

        {numEmptyInstances > 0 ? (
          <div className="text-white mt-2">
            <strong>
              You have <span className="text-orange">{numEmptyInstances}</span>{' '}
              unused instances! Follow these{' '}
              <a href="https://docs.snailbot.io/amazon" target="_blank">
                instructions
              </a>{' '}
              (pw: snailgang) to add an account and increase your chances of
              success.
            </strong>
          </div>
        ) : null}
      </>
    );
  }

  renderRedirect() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
  }

  render() {
    return (
      <>
        {this.renderRedirect()}
        {this.renderAlreadySubbedModal()}
        {this.renderDropdown()}
      </>
    );
  }
}

export default AccountSwitcher;
